'use client';

import { c as _c } from "react/compiler-runtime";
import { ImageWrapper } from '@module/mdrt-org/shared/components/image-wrapper/image-wrapper';
export type CarouselCardImageProps = {
  alt: string;
  className?: string;
  src: string;
};
export const CarouselCardImage = t0 => {
  const $ = _c(4);
  const {
    alt,
    className,
    src
  } = t0;
  let t1;
  if ($[0] !== alt || $[1] !== className || $[2] !== src) {
    t1 = <ImageWrapper alt={alt} className={className} fetchPriority="high" hasDefaultFallback={true} height={392} loading="eager" preload={true} sizes="(min-width: 1920px) 17vw, (min-width: 1200px) 21vw, (min-width: 940px) 33.33vw, (min-width: 600px) 50vw, (min-width: 360px) 84vw, 100vw" src={src} width={648} />;
    $[0] = alt;
    $[1] = className;
    $[2] = src;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};